import React from "react";
import { t } from "ttag";

import { Themed } from "../../../styles/themes";
import { Clickable } from "../../Clickables";
import { AppState, discountRules, evaluateDiscount } from "../engine";

import styles from "./ModalFooter.module.scss";

/**
 * Modal-surface footer chrome. Optional `left` / `right` slots host
 * whatever button each surface needs (Back / Continue / Skip-to-X /
 * Back to My Suite). Hub uses the slot-less form.
 */
export type ModalFooterProps = {
    state: AppState;
    onShowOfferDetails: () => void;
    left?: React.ReactNode;
    right?: React.ReactNode;
};

export const ModalFooter = ({
    state,
    onShowOfferDetails,
    left,
    right,
}: ModalFooterProps) => {
    const { qualified, ruleId } = evaluateDiscount(state.suite);
    const rule = qualified
        ? discountRules.find((r) => r.id === ruleId)
        : undefined;
    const ratePct = Math.round((rule ?? discountRules[0]).discountRate * 100);
    return (
        <Themed theme="offWhite" tag="footer" className={styles.row}>
            {left && <div className={styles.left}>{left}</div>}
            <p>
                {qualified
                    ? t`Congrats! You've unlocked ${ratePct}% Instant Savings.`
                    : t`Add eligible appliance(s) to unlock ${ratePct}% Instant Savings.`}{" "}
                <Clickable
                    onPress={onShowOfferDetails}
                    className={styles.detailsLink}
                >
                    {t`See Details`}
                </Clickable>
            </p>
            {right && <div className={styles.right}>{right}</div>}
        </Themed>
    );
};
